export const createProp = (type, defaults = null, required = false) => {
  return {
    type: type,
    default: defaults === null ? createDefaults(type) : defaults,
    required: required
  }
}

const createDefaults = (type) => {
  switch (type) {
    case Boolean: return false
    case Object: return () => { return {} }
    default: return ''
  }
}
